// extracted by mini-css-extract-plugin
module.exports = {"content":"RqbTG","video":"_8TRzk","video-text":"k-4CP","text-one":"Y2qA6","text-two":"_2-7DX","red":"_2Vjwk"};